import RemoveRoleFromUser from './RemoveRoleFromUser';

export default RemoveRoleFromUser;
